<script setup lang="ts">
import PassCard from "@/components/RegistrationPage/Card/PcVersion/PassCard.vue";
import WhitePassCard from "@/components/RegistrationPage/Card/PcVersion/white_pass/WhitePassCard.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";
import store from "@/store";

export default defineComponent({
    name: 'SubscriptionsHolder',

    data(): {
        order: string[]
    } {
        return {
            order: [
                'STAR_SHINE',
                'AURORA',
                'ANGULAR_MOMENTUM',

                'WHITE_PASS',

                'CMB_RADIATION',
                'DARK_MATTER',
                'BLACK_PASS',
            ]
        }
    },

    computed: {
        passes(): PassProperties[]
        {
            return store.state.passes.sort((a: PassProperties, b: PassProperties): number => this.order.indexOf(a.code) - this.order.indexOf(b.code))
        },
    },
})
</script>

<template>
    <div
        class="options"
    >
        <template
            v-for="(pass, i) in passes"
            :key="i"
        >
            <WhitePassCard
                v-if="pass.code === 'WHITE_PASS'"
                :pass="pass"
            />

            <PassCard
                v-else
                :pass="pass"
            />
        </template>

    </div>
</template>

<style scoped lang="scss">
.options {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    text-align: center;
    justify-content: center;
    max-width: 1172px;
    max-width: 1260px;
    gap: 35px 35px;
}
</style>
